$("[data-ga]").click(function(){
    if(typeof window.ga !== "function")return
    var cat = $(this).data('category');
    var action = $(this).data('action');
    var label = $(this).data('label');
    ga('send', 'event', cat, action, label);
});
